import {useMemo} from 'react';
import {LocalDateString} from '../../data/timeslots/apiTypes';
import {localStartOfDateForDateKey} from '@lib/logic';

export const useMemoDate = (dateKey: LocalDateString) => {
  const dateKeyPart = dateKey.slice(0, 'yyyy-MM-dd'.length);

  if (dateKey !== dateKeyPart) {
    console.warn('Warning: time part is stripped');
  }

  const date = useMemo(() => localStartOfDateForDateKey(dateKey), [dateKey]);
  return date;
};
